export default "__VITE_PUBLIC_ASSET__fa57e9d4__"